export class ConfigDB {
	static data = {
		settings: {
			sidebar: {
				sidebarClass:"compact-wrapper",
				layoutClass: 'default-sidebar'
			},
		},
		language:{
			defaultLang:'en'
		},
		color: {
			primary_color: '#26695c',
			secondary_color: '#c29873',
			mix_background_layout: 'light-only',
		},
	}
}
export default ConfigDB;
